import styled, { css } from 'styled-components';
import { FlexColumn } from '../../../../../styled/common';
import {
  SearchBar,
  SearchBarCity,
  SearchBarPlaceholder
} from '../../../common/FilterLocations/styled';

export const MainFiltersContainer = styled(FlexColumn)`
  padding: 15px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  width: 100%;
  gap: 15px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0;
    gap: 30px;
  }
`;

export const FilterLocationsWrapper = styled.div`
  height: 48px;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};

  ${SearchBar} {
    height: 48px;
  }

  ${SearchBarCity} {
    padding: 15px 0;
  }

  ${SearchBarPlaceholder} {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    width: 496px;
  }
`;

export const mainSectionStyles = css`
  padding: 0;
`;
